import { Component } from '@angular/core';
import { TableCellState } from '../../table.state';
import { CellActionTypes } from '../cell-actions.type';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { TableTooltipConfig } from '../../config/table-tooltip.config';

@Component({
  selector: 'app-cell-manage',
  templateUrl: './cell-manage.component.html',
  styleUrls: ['./cell-manage.component.scss'],
  providers: [{ provide: NgbTooltipConfig, useClass: TableTooltipConfig }],
})
export class CellManageComponent extends TableCellState {
  public confirm(): void {
    this.onAction(CellActionTypes.CONFIRM);
  }

  public reject(): void {
    this.onAction(CellActionTypes.REJECT);
  }
}
